import { Icon } from '@iconify/react';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default function AppointmentForm() {
  const [selectedDate, setSelectedDate] = useState(null);
  return (
    <form action="#" className="row">
      <div className="col-lg-6">
        <label className="cs_input_label cs_heading_color">Name</label>
        <input type="text" className="cs_form_field" placeholder="David John" />
        <div className="cs_height_42 cs_height_xl_25" />
      </div>
      <div className="col-lg-6">
        <label className="cs_input_label cs_heading_color">Phone Number</label>
        <input
          type="text"
          className="cs_form_field"
          placeholder="+92 123 3456789"
        />
        <div className="cs_height_42 cs_height_xl_25" />
      </div>
      <div className="col-lg-12">
        <label className="cs_input_label cs_heading_color">
          Address
        </label>
        <input
          type="text"
          className="cs_form_field"
          placeholder="Address"
        />
        <div className="cs_height_42 cs_height_xl_25" />
      </div>
     
      <div className="col-lg-12">
  <label className="cs_input_label cs_heading_color">
    Reason for Availing Services
  </label>
  <div className="cs_radio_group">
    <div className="cs_radio_wrap">
      <input
        className="cs_radio_input"
        type="radio"
        name="reasonForService"
        id="routineService"
        defaultValue="routineService"
      />
      <label className="cs_radio_label" htmlFor="routineService">
        Routine Service
      </label>
    </div>
    <div className="cs_radio_wrap">
      <input
        className="cs_radio_input"
        type="radio"
        name="reasonForService"
        id="newService"
        defaultValue="newService"
        defaultChecked=""
      />
      <label className="cs_radio_label" htmlFor="newService">
        New Service
      </label>
    </div>
    <div className="cs_radio_wrap">
      <input
        className="cs_radio_input"
        type="radio"
        name="reasonForService"
        id="specificService"
        defaultValue="specificService"
      />
      <label className="cs_radio_label" htmlFor="specificService">
        Specific Service
      </label>
    </div>
  </div>
  <div className="cs_height_42 cs_height_xl_25" />
</div>
<div className="col-lg-12">
  <label className="cs_input_label cs_heading_color">Service Department</label>
  <div className="cs_radio_group">
    <div className="cs_radio_wrap">
      <input
        className="cs_radio_input"
        type="radio"
        name="serviceDepartment"
        id="pediatricService"
        defaultValue="pediatricService"
      />
      <label className="cs_radio_label" htmlFor="pediatricService">
        Pediatric Services
      </label>
    </div>
    <div className="cs_radio_wrap">
      <input
        className="cs_radio_input"
        type="radio"
        name="serviceDepartment"
        id="obstetricsGynecologyService"
        defaultValue="obstetricsGynecologyService"
        defaultChecked=""
      />
      <label className="cs_radio_label" htmlFor="obstetricsGynecologyService">
        Obstetrics and Gynecology Services
      </label>
    </div>
    <div className="cs_radio_wrap">
      <input
        className="cs_radio_input"
        type="radio"
        name="serviceDepartment"
        id="cardiologyService"
        defaultValue="cardiologyService"
      />
      <label className="cs_radio_label" htmlFor="cardiologyService">
        Cardiology Services
      </label>
    </div>
    <div className="cs_radio_wrap">
      <input
        className="cs_radio_input"
        type="radio"
        name="serviceDepartment"
        id="neurologyService"
        defaultValue="neurologyService"
      />
      <label className="cs_radio_label" htmlFor="neurologyService">
        Neurology Services
      </label>
    </div>
  </div>
  <div className="cs_height_42 cs_height_xl_25" />
</div>

      <div className="col-lg-12">
        <button className="cs_btn cs_style_1">
          <span>Submit</span>
          <i>
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
          </i>
        </button>
      </div>
    </form>
  );
}
